module.exports = __webpack_public_path__ + "static/book-374f5fa9f20c71254e24e02f477e9234.gif";